export const environment = {
  production: true,
  apiUrl: 'https://service-backend-px3u.onrender.com/api',
  urlBaseApi: 'https://service-backend-px3u.onrender.com/api/', // Base URL for API endpoints with trailing slash
  database: {
    // Production database settings
    host: 'your-production-db-host',
    port: 3307,
    username: 'user_crud',
    password: 'root',
    database: 'db_crud',
    timezone: 'America/Mexico_City'
  },
  // Other production settings
  cors: {
    allowedOrigins: ['https://service-backend-h4wg.onrender.com'],
    allowedMethods: ['GET', 'POST', 'PUT', 'DELETE'],
    allowCredentials: true,
    maxAge: 86400
  },
  jwt: {
    secret: 'your-production-secret-key',
    expiresIn: '24h'
  },
  storageSecretKey: 'punto-de-storage-local-key-v1-ñadjekjbda5244'
};

